import { useEffect } from "react";
import styled from "styled-components";
import LionsFlag from "./img/obj_flag_a.gif"


function Rankings() {

    useEffect(() => {
            
            setTimeout(() => {
                document.getElementById('RankingsMaster').style.opacity = "1";
            }, 300);
        },[]);

    return(
        <RankingsContainer id='RankingsMaster'>
            <TitleContainer>
                <Title>Rankings Gerais</Title>
                <T1>
                    <p>Em breve disponibilizaremos a nossa página de Rankings. Fique ligado!<br/></p>
                </T1>
            </TitleContainer>
            <RankingsFlag img={LionsFlag}/>
        </RankingsContainer>
             )
}

export default Rankings;

const RankingsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;
    transition: 2s;
    margin-bottom: 50px;
    opacity: 0;
    //border: solid;

    @media (max-width: 1000px) {
    width: 90vw;
    margin-top: 30px;
    }

`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1280px;

    @media (max-width: 1000px) {
    width: 90%;
    //text-align: justify;
    margin-bottom: 50px;
    }
`;

const Title = styled.h1`
    font-size: 30pt;

    @media (max-width: 1000px) {
    font-size: 28pt;
    text-align: center;
    }
`;

const T1 = styled.div`
    width: 1000px;
    padding: 10px 20px;
    //border: solid;
    text-align: center;
    font-size: 13pt;


    @media (max-width: 1000px) {
    width: 100%;
    overflow: auto;
    padding: 10px;
    border-radius: 10px;
    //box-shadow: 0 0 10px 0 black;
    font-size: 11pt;
    }

`;

const RankingsFlag = styled.div`
    background-image: url('${props => props.img}');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 123px;
    height: 248px;
    margin: 0 22px 0 0;
    
`

const Input = styled.input`
    font-size: 14pt;
    width: 700px;
    padding: 5px 0 5px 5px;
    border-radius: 5px;
    border: solid 1px;
    text-align: center;
    margin-bottom: 10px;

    @media (max-width: 1000px) {
    width: 90vw;
    }
`

const Submit = styled.div`
    font-size: 14pt;
    width: 20%;
    padding: 5px 0 5px 5px;
    border-radius: 5px;
    border: solid 1px;
    background-color: rgba(5, 91, 144, 1);
    color: white;
    margin: 5px 0 70px 0px;
    transition: .2s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    box-shadow: 0 0 5px 0 black;
    scale: 1.1;
    }
        
`

const ItemListMasterContainer = styled.div`
    display: flex;
    //flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    //border: solid;

`

const RoItemMasterContainer = styled.div`
    display: flex;
    flex-direction: column;
    //border: solid 1px;
    border-radius: 10px;
    padding: 10px 30px;
    transition: .2s ease-in-out;
    margin: 10px 10px;
    box-shadow: 0 0 3px 0 black;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
    box-shadow: 0 0 5px 0 black;
    scale: 1.1;
    z-index: 2;
    background-color: white;
    }

    @media (max-width: 1000px) {
    scale: .9;
    margin-bottom: 5px;

        &:hover {
            scale: 1;
        }
    }
`


const RoItemHeader = styled.div`
    display: flex;
    align-items: center;
    //border: solid 1px;
    border-radius: 10px;
    //background-color: rgba(19, 91, 158, 0.5);
`
const RoItemIcon = styled.div`
    background-image: url('/database/itemPng/${props => props.img}.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    margin: 0 22px 0 0;
    
`
const RoItemName = styled.div`
    display: flex;
    align-items: center;
    //border: solid 1px;
    padding: 10px 5px;
    font-size: 14pt;
    font-weight: bold;
`

const RoItemBody = styled.div`
    display: flex;
    align-items: center;
    //border: solid 1px;
`

const RoItemCollection = styled.div`
    background-image: url('/database/collection/${props => props.img}.bmp');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 75px;
    height: 100px;
`

const RoItemDescription = styled.div`
    width: 700px;
    text-align: left;
    padding: 20px;
    //border: solid 1px;

    @media (max-width: 1000px) {
    width: 60vw;
    padding: 5px
    }
`

const CardImage = styled.div`
    background-image: url('/database/cardbmp/${props => props.img}.bmp');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 350px;
    height: 470px;
    box-shadow: 0 0 10px 0px black;
    border: solid 1px;
    z-index: 30;

    @media (max-width: 1000px) {
    width: 600px;
    height: 800px;
    }


`


